<template>
    <div class='login-form'>
        <div>
            <img src='https://uploads-ssl.webflow.com/61373db96e1a1814e5edae40/61373db96e1a18e76fedae89_logo_rentateam.svg' alt='RentaTeam' />
        </div>
        <h1 class='login-form__hero'>
            Need awesome message
        </h1>
        <div class='login-form__button'>
            <button @click='handleLogin()' class='btn btn-primary btn-sm' :disabled='loading'>
                <i class='fas fa-sign-in-alt login-form__button-icon'></i>
                {{ loading ? 'Signing in...' : 'Sign in' }}
            </button>
        </div>
    </div>
</template>

<style>
.login-form {
    margin: auto;
    display: flex;
    flex-direction: column;
}
.login-form__button {
    margin-top: 1rem;
    align-self: center;
}
.login-form__button-icon {
    margin-right: 0.5rem;
}
</style>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import router from '@/router';

export default {
    data() {
        return {
            loading: false,
        };
    },
    computed: {
        ...mapState('auth', [
            'user',
        ]),
        ...mapGetters('auth', [
            'isAuthenticated',
        ]),
    },
    methods: {
        ...mapActions('auth', [
            'openOidcPopup',
            'loginOidc',
        ]),
        async handleLogin() {
            this.loading = true;
            try {
                const { code, redirectUri } = await this.openOidcPopup();
                await this.loginOidc({ code, redirectUri });
            } catch (error) {
                console.error('Login failed:', error);
            } finally {
                this.loading = false;
            }
        },
    },
    created() {
        if (this.isAuthenticated) {
            router.push('/');
        }
    },
};
</script>
